<template>
  <div>
    <WebHeaderView :title="'支付密码'" />
    <div class="page-content">
      <div class="addMethod">
        <van-form @submit="changePwd">
        <div class="frm" v-if="usr.is_setpay == 1">
          <div class="title">旧密码</div>
          <van-field
            v-model="frm.password"
            type="password"
            placeholder="请输入旧密码"
            :rules="[{ pattern: /^\d+$/, message: '只能输入数字' }]"
          />
        </div>
        <div class="frm">
          <div class="title">支付密码</div>
          <van-field
            v-model="frm.paypassword"
            type="password"
            placeholder="请输入支付密码"
            :rules="[{ pattern: /^\d+$/, message: '只能输入数字' }]"
          />
        </div>
        <div class="frm">
          <div class="title">密码确认</div>
          <van-field
            v-model="frm.agepwd"
            type="password"
            placeholder="请再次输入新密码"
            :rules="[{ pattern: /^\d+$/, message: '只能输入数字' }]"
          />
        </div>
        <div class="frm" style="margin-top: 40px;text-align: right;">
          <van-button block class="post-btn" native-type="submit" style="width: 96% !important; margin: 20px auto;color: #fff;">修改</van-button>
       
          <a @click="$router.push({ name: 'findpwd'});" style="color:#cca352;font-weight: 600;">忘记支付密码</a>
        </div>
         </van-form>
      </div>
    </div>
  </div>
</template>

<script>
import WebHeaderView from '@/components/Header/index.vue'
export default {
  name: 'ChangePwdView',
  components: { WebHeaderView },
  data(){
    return {
        frm:{
            password:null,
            paypassword:null,
            agepwd:null
        },
        usr:{}
    }
  },
  mounted(){
    this.getusrInf()
  },
  methods:{
    async changePwd(){
      if (!this.frm.password && this.usr.is_setpay == 1) {
        this.$toast.fail('请输入旧密码')
        return
      }
      if (!this.frm.paypassword) {
        this.$toast.fail('请输入支付密码')
        return
      }
      if (this.frm.paypassword == this.frm.password) {
        this.$toast.fail('旧密码和新密码相同')
        return
      }
      if (this.frm.paypassword != this.frm.agepwd) {
        this.$toast.fail('新密码两次输入不同')
        return
      }

      await this.$http({
        method: 'post',
        url: 'editPayPassword',
        data: this.frm
      }).then(data => {
        this.$toast.success(data.msg)
        this.frm = {
            password:null,
            paypassword:null,
            agepwd:null
        }
      })
    },
    async getusrInf () {
      await this.$http({
        method: 'post',
        url: 'usrInf'
      }).then(data => {
        this.usr = data.data
      })
    }, 
  }
}
</script>
<style lang="scss" scoped>
.addMethod {
  width: 94%;
  margin: 10px auto;
  text-align: left;
  .frm {
    margin: 10px 0;
    .title {
      margin-bottom: 8px;
    }
  }
}
</style>
<style>
.addMethod .van-cell {
  background-color: #222 !important;
}
.addMethod .van-field__control {
  color: #fff !important;
}
.resarch-box {
  margin-top: 20px;
}
.resarch-box input {
  color: #fff !important;
}
</style>
